// extracted by mini-css-extract-plugin
module.exports = {"indentedCheckbox":"MarketingConsentForm_indentedCheckbox__ySPNv","textLabel":"MarketingConsentForm_textLabel__qJq1J"};